export enum AnimcoTypeEnum {
    MOBILE_RECOVERY = 'mobile_recovery',
    PROMO_CODE = 'promo_code',
    DISCOUNT = 'discount',
    DEFERED_DISCOUNT = 'defered_discount',
    OTHER = 'other',
}

export interface PalpatineProduct {
    Slug: string;
    highlight?: {
        items: PalpatineProductHighlights[];
    };
    stickers?: {
        items: PalpatineProductStickers[];
    };
    anim_animco_list: {
        items: {
            type: AnimcoTypeEnum;
            promo_code?: string;
            text: string;
            tooltip?: string;
            start_date?: string;
            end_date?: string;
            order: number;
            parcours: string[];
        }[];
    };
    banner_animco_list: {
        items: {
            display_sticker: boolean;
            sticker_value: string;
            text: string;
            start_date?: string;
            end_date?: string;
            parcours: string[];
        }[];
    };
    id_les_numeriques: string | null;
}

export interface PalpatineBonusPlan {
    id: number;
    forfait_bonus_reprise: string;
}

export interface PalpatineProductHighlights {
    start_date?: string;
    end_date?: string;
    parcours: ('ACQUISITION' | 'RENOUVELLEMENT')[];
    label_price: number | null;
    label_price_exponent: string | null;
    stamp: { public_url: string } | null;
    stamp_alt: string | null;
}

export interface PalpatineProductStickers {
    name: string;
    sticker_text: string;
    sticker_color: string;
    start_date?: string;
    end_date?: string;
    id: number;
    parcours: ('ACQUISITION' | 'RENOUVELLEMENT')[];
}

export type PalpatineStickerItemType = {
    id: number;
    order: number;
};

export type PalpatineStickerType<T extends PalpatineStickerItemType> = {
    id: string;
    slug: string;
    banners: {
        items: T[];
    };
};

export type PalpatinePlanType = {
    id: string;
    slug: string;
    text_popin: string;
    acq_renew: ('acquisition' | 'renouvellement')[];
    forfait_details: { icone_trilogy: string; pepite: string }[];
};
